import { render } from "./TransactionSuccessPage.vue?vue&type=template&id=f64fd566&ts=true"
import script from "./TransactionSuccessPage.vue?vue&type=script&lang=ts"
export * from "./TransactionSuccessPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__